<template>
    <v-dialog
        v-model="isDialog"
        persistent
        max-width="50%"
        style="height: 100%;"
    >

        <v-card style="height: 100%">

            <v-card-text style="height: 50%">
                <div class="button-position">
                    <v-btn
                        class="mx-2"
                        fab
                        dark
                        small
                        color="primary"
                        @click="clickCloseButton"
                    >
                        <v-icon dark>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </div>
                <div>
                    <div  class="device-dialog-wrapper">
                        <p class="device-dialog-title">장치 명령어 등록</p>
                        <select-box-single-check
                            :items="computedCmdOptions"
                            :label="'명령어 타입 선택' | translate"
                            style="margin-bottom: 10px"
                            v-model="selectedCmdCodeKey"
                        />
                        <!--프린트 선택 : 프린트 정보가 필요한 명령어만 보여집니다.-->
                        <template v-if="validateCheckData.length">
                            <select-box-single-check
                                :items="printOptions"
                                :label="'프린트 선택' | translate"
                                v-model="selectedPrintId"
                            />
                        </template>
                        <div class="cmd-data-wrapper">
                            <v-textarea
                                class="vuetify-textarea"
                                style="width: 100px; margin-top: 20px"
                                :label="'명령어 데이터 입력' | translate"
                                outlined
                                v-model="commandData"
                            ></v-textarea>
                            <div class="example-cmd-data">
                                <p class="example-cmd-data-text" >
                                    {{exampleCmdData}}
                                </p>
                            </div>
                        </div>

                    </div>
                    <div class="detail-button-wrapper">
                        <button @click="completeButtonClick" class="button-complete-style">
                            작성완료
                        </button>
                    </div>
                </div>
            </v-card-text>

        </v-card>
    </v-dialog>
</template>

<script>
import SelectBoxSingleCheck from "@/components/selectBox/SelectBoxSingleCheck";
import selectOptions from "@/components/selectBox/selectOptions";

const EXAMPLE_CMD_DATA={
    401:'예시 : \n\n'+
        '{"FileName":"installerversion.json"}\n'+
        '{"FileName":"loginInfo.json"}\n' +
        '{"FileName":"printerInfos.json"}\n' +
        '{"FileName":"versions.json"}',
    402:'예시 : \n\n ' +
        '1.loginInfo.json 내용 설정\n' +
        '{"FileName":"loginInfo.json","ConfigInfoData":"{\\"rentalCompanyId\\":1000123,\\"accountId\\":205209,\\"installDept\\":\\"\\",\\"loginId\\":\\"toprinter\\",\\"password\\":\\"jgE1CiyjHtY=\\",\\"mac\\":\\"0A:00:27:00:00:11\\",\\"osVersion\\":\\"Microsoft Windows NT 10.0.19042.0\\",\\"pgVersion\\":\\"1.0.0.1\\",\\"rentalCompanyName\\":\\"탑프린터\\",\\"deviceSerial\\":\\"2110001232052091EXF4\\",\\"ip\\":\\"192.168.56.1\\",\\"manualYn\\":\\"Y\\",\\"isUseIBlock\\":false,\\"isUseIBlockRentalCompany\\":true,\\"lastLoginTime\\":\\"0001-01-01T00:00:00\\",\\"deviceType\\":\\"PC\\"}"}\n\n' +
        '2.printerInfos.json 내용 설정\n' +
        '{"FileName":"printerInfos.json","ConfigInfoData": "[{\\"manufacturerName\\":\\"Canon\\",\\"modelName\\":\\"Canon MB2320\\",\\"serial\\":\\" AEHC63961\\",\\"ipAddress\\":\\"192.168.0.123\\",\\"deviceSerial\\":\\"21100135217880KZ4CFS\\",\\"vendor\\":null,\\"isLocal\\":false,\\"connectedType\\":0,\\"ciss\\":1,\\"usbPath\\":null}]"}\n\n' +
        '**주의사항** \n' +
        'json파일 설정 내용(ConfigInfoData의 내용)의 쌍따옴표(")는 앞에 역슬래시(\\)를 붙여야 정상적으로 설정이 됩니다.',
    901:'예시: 192.168.0.100'
}
const DEFAULT_EXAMPLE_CMD_DATA = '명령어 데이터 예시가 없습니다.'

export default {
    name: "CommandModal",
    components: {SelectBoxSingleCheck},
    data() {
        return {
            cmdOptions:selectOptions.DEVICE_DETAIL.CMD_OPTIONS, //명령어 데이터 입니다.
            selectedCmdCodeKey: undefined,//선택한 명령어입니다.
            selectedPrintId:undefined, //선택한 프린트 입니다.
            commandData:undefined,//작성한 명령어 내용입니다.,
            exampleCmdData:DEFAULT_EXAMPLE_CMD_DATA
        }
    },
    props: {
        isDialog: {
            type: Boolean,
            default: false
        },
        items:{//모든 테이블 데이터가 있습니다.
            type: Object,
            default: ()=>{}
        },
        connectedPrintListWithStatus:{
            type: Array,
            default: ()=>[]
        },
        searchedPrintListWithStatus:{
            type: Array,
            default: ()=>[]
        },
    },
    computed: {
      computedCmdOptions() {
        if(!!this.items.devices[0] &&this.items.devices[0].deviceType === 'DV') {
          return this.cmdOptions.filter((e) => e.codeKey !== 302 && e.codeKey !== 303 )
        } else {
          return this.cmdOptions
        }
      },
        /**
         * 선택한 옵션마다 요청시 필요한 프린트 데이터가 있습니다.
         * 그 목록을 반환합니다.
         * @returns {(function(): ([]|*))|*|string[]|*[]}
         */
        validateCheckData(){
            const selectedCmd = this.cmdOptions.find(({codeKey})=> codeKey === this.selectedCmdCodeKey)
            if(!selectedCmd) return []
            return selectedCmd.validateCheckData || []
        },
        /**
         * 연결된 프린트하고 검색된 프린트 배열을 합쳐서 프린트 배열을 만듭니다
         * 그런데 프린트 중 각 명령어마다 명령어를 전송한 프린트는 제외됩니다.
         * @returns {*[]}
         */
        printList(){
            if(this.selectedCmdCodeKey === 101){//연결된 프린트일때 전송상태가 0 이 아닌거 제외
                return this.connectedPrintListWithStatus.filter(({cmdStatus})=> cmdStatus === 0)
            }else if(this.selectedCmdCodeKey === 100){ //검색된 프린트일대 전송상태가 0 이 아닌거 제외
                return this.searchedPrintListWithStatus.filter(({cmdStatus})=> cmdStatus === 0)
            }else return [...this.searchedPrintListWithStatus,...this.connectedPrintListWithStatus]
        },
        /**
         * selectbox 클릭시 나오는 프린트 목록을 표기하기위한 데이터입니다.
         * @returns {{codeKey: *, codeValue: string}[]}
         */
        printOptions(){
            return this.printList.map(({modelName,serialNo,ip})=>({codeValue: `${modelName} [${serialNo}]`, codeKey: {serialNo, ip}}))
        },
        /**
         * 선택한 프린트 객체를 반환합니다.
         * @returns {undefined|*}
         */
        selectedPrint(){
            if(!this.selectedPrintId) return undefined
            return this.printList.find(({ip, serialNo})=> serialNo === this.selectedPrintId.serialNo && ip === this.selectedPrintId.ip)
        },
        /**
         * 명령어에따라 필요한 프린트 데이터들이 있는데
         * 선택한 프린트 데이터에 있는지 없는지 체크합니다
         * true: 요청불가능
         * false: 요청가능
         * @returns {boolean}
         */
        noRequiredPrintData(){
            if(!this.validateCheckData.length) return false//체크할 데이터가 없을때 전송가능합니다. validateCheckData은 무조건 배열
            if(!this.selectedPrint)return true //체크해야될 데이터가 있는데 printer를 선택 안했을때

            //printer데이터가 있을때 원하는 값이 있는지 체크 하나라도 없으면 true
            return this.validateCheckData.some((checkData)=>{
                return !this.selectedPrint[checkData]
            })
        },
        /**
         * 명령어 내용을 필수로 입력해야되는 명령어가 있습니다
         * 901,402,401
         * true: 명령어 내용을 작성 안했습니다.
         * false: 명령어 내용을 작성했습니다 or 필수 작성이 아닌 명령어
         * @returns {boolean}
         */
        noRequiredCmdData(){
            if(!this.selectedCmdCodeKey) return false
            const isRequiredInputCmd = this.selectedCmdCodeKey===901|| this.selectedCmdCodeKey === 401|| this.selectedCmdCodeKey ===402
            return isRequiredInputCmd && (!this.commandData ||!this.commandData.trim())
        },

    },
    watch: {
        /**
         * selectedCmdCodeKey 가 바뀔때 동작합니다
         * selectedCmdCodeKey 값이 없을때 cmd의 필요 데이터 목록이 없을때 selectedPrintId 를 초기화 합니다
         * 401하고 402때 고정된 text 를 예시 box에 보여주고 다른 cmd로 이동시에는 설정한 default text값을 보여줍니다.
         */
        selectedCmdCodeKey:{
            handler(newValue){
                if(!newValue || !this.validateCheckData.length){
                    this.selectedPrintId=undefined
                }
                //402랑 401일때 명령어 예시 text를 보여줍니다.
                const cndExpression = newValue === 401 || newValue ===402 || newValue === 901
                if(cndExpression) this.exampleCmdData = EXAMPLE_CMD_DATA[newValue]
                else this.exampleCmdData=DEFAULT_EXAMPLE_CMD_DATA

            }
        },
        /**
         * selectedPrintId 가 바뀔때 동작합니다
         * cmd가 901이면서 선택한 printer의 ip가 있을때는 ip를 예시로 보여주고 다른 cmd로 이동시에는 설정한 default text값을 보여줍니다.
         */
        selectedPrintId:{
            handler(){
                const cndExpression = this.selectedCmdCodeKey === 901 && this.selectedPrint && this.selectedPrint.ip
                if(cndExpression)this.commandData=this.selectedPrint.ip
                else this.commandData=undefined
            }
        }


    },
    methods: {

        init(){
            this.selectedCmdCodeKey=undefined
            this.selectedPrintId=undefined
            this.commandData=undefined
        },
        /**
         * 모달 상단에 - 버튼 클릭시 동작합니다.
         */
        clickCloseButton() {
            this.$confirm("저장하지않고 나가시겠습니까?")
                .then(() => {
                    this.$emit("click-command-modal",'close')
                    this.init()
                })
        },
        /**
         * 작성하기 버튼 클릭시 동작합니다.
         */
        completeButtonClick() {
            if(!this.selectedCmdCodeKey) {
                this.$alert("명령어 타입을 선택하세요")
                return
            }
            if(this.noRequiredPrintData) {
                this.$alert("명령어에 필요한 데이터가 없습니다.")
                return
            }
            if(this.noRequiredCmdData) {
                this.$alert("명령어 데이터를 필수로 입력하세요")
                return
            }
            this.$confirm("저장하시겠습니까?")
                .then(() => {
                    const cmd = this.selectedCmdCodeKey
                    const deviceType = this.items.devices[0].deviceType
                    const reqBodyData={
                        cmd,
                        data:this.commandData,
                        ...this.selectedPrint,
                        deviceType
                    }
                    //검색된 프린트는 printerSerialNo가 없어서 serialNo의 값을 넣어 요청을 보냅니다.
                    if(cmd === 100 || cmd === 101 || cmd === 901) reqBodyData.printerSerialNo=this.selectedPrint.serialNo

                    this.$emit("cmd-insert-data-load",reqBodyData,)
                    this.$emit("close-command-modal")
                    this.init()
                })

        }
    },
    created() {
    }

}
</script>

<style scoped>
.with-full-size{
    width: 100%;
}
.button-position{
    text-align: right;
    margin-right: 10px;
    margin-top: 10px;
    margin-bottom: 20px;
}

>>>.v-dialog {
    overflow-y: visible;

}
>>>.v-dialog:not(.v-dialog--fullscreen) {
    max-height: none;

}
>>>.v-dialog .v-card .v-card__text{
    overflow-y: hidden;

}
/*버튼 그룹입니다.*/
.detail-button-wrapper{
    width: 100%;
}
/*작성하기 버튼 부분입니다.*/
.button-complete-style{
    background-color: #42b983 !important;
    border-color: #42b983 !important;
    padding: 6px 0;
    border-radius: 5px;
    width: 100%;
    color: #eeeeee;
    margin-top: 10px;
    margin-right: 20px;
}
.device-dialog-wrapper{
    display: flex;
    flex-direction: column
}
.device-dialog-title {
    font-weight: bold;
    font-size: 25px;
    align-self: flex-start;
    margin-bottom: 50px
}
.cmd-data-wrapper{
    display: flex;
    height: 100%;
}
 >>> .v-input__control .v-input__slot .v-text-field__slot textarea{
    height: 400px !important;
    overflow: auto;
    font-size: 14px;
}
 /*예시 텍스트 부분입니다.*/
.example-cmd-data{
    width: 400px;
    border: 1px solid rgba(0, 0, 0, 0.38);
    border-radius:4px;
    height: 410px;
    margin-top: 20px;
    margin-left: 10px;
    padding-left: 12px;
    padding-top: 10px;
}
.example-cmd-data-text{
    width: 100%;
    line-height: 20px;
    font-size: 14px;
    text-align: left;
    height: 100%;
    overflow: auto;
    white-space: pre-wrap;
}
</style>